<template>
  <div class="close" role="button">
    <span class="tip">削除</span>
    <FontawesomeIcon :icon="['far','times']" />
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'

export default defineComponent({
  props: {
    isChecked: {
      type: Boolean,
      default: false
    }
  },
  setup (props, context) {

    const group1 = reactive({
      isChecked: computed(() => { return props.isChecked })
    })

    return {
      group1
    }
  }
})
</script>

<style lang="scss" scoped>
.close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  position: relative;
  color: $color-content;
  border-radius: 4px;
  transition: box-shadow .2s;
  .tip {
    color: $color-link;
    font-size: 1.4rem;
    white-space: nowrap;
    position: absolute;
    top: -20px;
    left: 50%;
    transform: translate3d(-50%,0,0);
    opacity: 0;
    transition: opacity .2s;
  }
  &:hover {
    box-shadow: 0 3px 6px rgba(0,0,0,.16);
   .tip {
     opacity: 1;
   } 
  }
}
</style>
